<template>
  <div class="h-full overflow-hidden">
    <ul class="flex gap-x-5 items-center">
      <strong>{{ state.model?.name }}</strong>
      <c_cell title="入住日期" />
    </ul>
    <div class="min-h-[50vh] p-2.5 rounded-md bg-gray-100 overflow-y-auto flex flex-col">
      <ul class="flex items-center">
        <c_cell title="需求" :value="state.model?.count" />
        <c_cell title="已配置" :value="state.model?.count" />
        <c_cell title="已分房" :value="state.model?.count" class="flex-1" />
        <el-button type="primary" icon="plus" size="small" link>新增</el-button>
        <el-button type="primary" icon="Download" @click="onImport()" link>
          导入Excel
        </el-button>
      </ul>
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_hotelArrange_room_type_detail } from "@/http/meeting";

export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      console.log(props);

      if (props.id) {
        meeting_hotelArrange_room_type_detail(props.id).then((res) => {
          if (res.status == 200) state.model = res.data?.data || {};
        });
      }
    });
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
